import React, { useState, useEffect, FC } from "react";
import { Box, Typography, Stack, Button, InputLabel } from "@mui/material";

import { Link, useNavigate } from "react-router-dom";

import { useTheme } from "@mui/material/styles";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { onboardingSchema } from "../../validate/authentication";
import { NameInput } from "../ui-elements/inputs";
import InputPassword from "../ui-elements/input-password";
import {
  btnApple,
  btnGoogle,
  btnStyOne,
  line,
  lineText,
} from "../ui-elements/styles-button";
import { Image } from "@mui/icons-material";
import { InputCustom } from "../ui-elements/input-ui";
import { labelSty } from "../ui-elements/styles-input";
import CustomDatePicker from "../ui-elements/date-picker";
import { Dayjs } from "dayjs";
import SelectInput from "../ui-elements/select";
import { OnboardContentProps, OnboardData } from "../../interface/onboard";
import { formatDateFromString } from "../../utils/date-setup";
import { validate_onboarding } from "../../validate/onboarding";
import { useNotificationService } from "../../hooks/notification";
import { RequiredIcon } from "../ui-elements/svg-icons";
import useResponsive from "../../hooks/useResponsive";

export const ScreenOne = ({
  next,
  user_data,
  setUser_data,
  states,
  lga,
}: OnboardContentProps) => {
  // set up validation
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const { showNotification } = useNotificationService();
  const isMedium = useResponsive("down", "md", "xl");

  const handle_date = (newValue: Dayjs | null) => {
    if (!newValue) return;
    setSelectedDate(newValue);
    const date = new Date(newValue.toString());
    const formattedDate =
      date.getFullYear() +
      "-" +
      String(date.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(date.getDate()).padStart(2, "0");

    setUser_data((prev) => ({ ...prev, dob: formattedDate }));
  };
  const handle_state = (id: number) => {
    setUser_data((prev) => ({
      ...prev,
      state_id: id.toString(),
    }));
  };
  const handle_lga = (id: number) => {
    setUser_data((prev) => ({
      ...prev,
      local_government_id: id.toString(),
    }));
  };

  const on_submit = async (e: any) => {
    e.preventDefault();
    // validate the inputs
    
    const result = await validate_onboarding(user_data, showNotification);
    if (result) {
      next();
    }
  };
  return (
    <Box sx={{ width: isMedium ? "98%" : 620, mx: "auto" }}>
      <Box sx={{ my: 2 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 500,
            color: "#26203B",
            textAlign: "center",
          }}
        >
          Let’s Personalise Your iRep Experience!
        </Typography>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 400,
            color: "#9C9AA5",
            textAlign: "center",
            width: "90%",
            mx: "auto",
          }}
        >
          We'll tailor your news feed and recommendations to your specific
          location, ensuring you stay informed about what matters most in your
          community.
        </Typography>
      </Box>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={on_submit}
        sx={{ width: isMedium ? "90%" : "80%", mx: "auto" }}
      >
        <Stack sx={{ width: "100%", my: 2 }}>
          <InputLabel sx={{ ...labelSty }}>
            Full Name <RequiredIcon />
          </InputLabel>
          <InputCustom
            placeholder={"Type full name here"}
            value={user_data?.name}
            onchange={(e: any) =>
              setUser_data((prev) => ({ ...prev, name: e.target.value }))
            }
            type={"text"}
            size={"medium"}
            styles={{}}
          />
        </Stack>
        <Stack sx={{ width: "100%", my: 2 }}>
          <InputLabel sx={{ ...labelSty }}>
            Date of birth <RequiredIcon />
          </InputLabel>
          <CustomDatePicker
            value={selectedDate}
            onChange={handle_date}
            label={"Select date"}
          />
        </Stack>
        <Stack sx={{}}>
          <InputLabel sx={{ ...labelSty }}>
            Gender <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={user_data?.gender}
            onChange={(e) =>
              setUser_data((prev) => ({ ...prev, gender: e.target.value }))
            }
            options={[
              { value: "", label: "Select Gender" },
              { value: "male", label: "Male" },
              { value: "female", label: "Female" },
            ]}
          />
        </Stack>
        <Stack sx={{ my: 2 }}>
          <InputLabel sx={{ ...labelSty }}>
            What’s your state of primary residence? <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={user_data.state_id}
            onChange={(e) => handle_state(e.target.value)}
            options={states}
          />
        </Stack>
        <Stack sx={{}}>
          <InputLabel sx={{ ...labelSty }}>
            What’s your local government of primary residence? <RequiredIcon />
          </InputLabel>
          <SelectInput
            value={user_data.local_government_id}
            onChange={(e) => handle_lga(e.target.value)}
            options={lga}
          />
        </Stack>

        <Stack direction={"row"} justifyContent={"center"} sx={{ my: 2 }}>
          <Button
            variant="contained"
            type="submit"
            sx={{ ...btnStyOne, width: isMedium ? "90%" : "80%" }}
          >
            Continue
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};
